import dayjs, { Dayjs } from 'dayjs';

export const getTime = (time: Dayjs | null) =>
  !time ? '' : dayjs(time).format('HH:mm:ss');
